import {path, alias, expr, middleware, validate, createMany, index, Closure, incomplete} from '@acng/frontend-voyager';
import {replaceUrl} from '@acng/frontend-relativity/history';
import {guard, IS} from '@acng/frontend-rubicon';

import {main} from '../../core/service/location.js';
import {amateurRoute} from 'acng/amateurPool/config/routes';
import {mainView, stickyView} from 'acng/layout/service/sequence.js';
import {onlyUserOrPreview} from 'acng/userPool/config/middleware';
import {authUser} from '../../userPool/context/auth-user.js';
import {MoviesVisit} from '../../Lib/Log/events/visit.js';
import {logger} from '../../Lib/Log/client.js';
import {Amateur} from '../../amateurPool/model/amateur.js';

import {moviePoolFeature} from './feature.js';

import {LocalActor} from '@acng/frontend-relativity';
import {ctxGallery} from 'acng/core/context/gallery.js';
import {documentElement} from '@acng/frontend-bounty';
import {get} from '../service/cache.js';
import {ctxMovie} from '../context/movie.js';
import {Movie} from '../model/movie.js';

main.create(
  onlyUserOrPreview, //
  incomplete,
  expr(/^(?:\/sedcard\/.+)?\/movies/y),
  // TODO keep old route (deeplinks case) , make redirect to new default movie/pictures list route
  // TODO alias is required by onswCategorySelect in sidebar this makes it a bit complicated
  alias('movies'),
  createMany(
    [
      // sedcard and legacy
      index,
      mainView(moviePoolFeature, 'movies'),
    ],
    [
      path('/{type}'),
      validate(({type}) => /^(top|new|classics)$/.test(/** @type {string} */ (type))),
      stickyView(moviePoolFeature, 'list-header'),
      mainView(moviePoolFeature, 'movies'),
    ]
  )
);

amateurRoute.create(
  path('/movies'),
  Closure((params) => {
    if (!authUser) {
      return;
    }

    const {amateur} = params;
    ASSERT: guard(amateur, IS(Amateur));
    const laforgeEvent = new MoviesVisit(authUser.uid, amateur);

    return () => logger.send(laforgeEvent.endVisit());
  }),
);

const provideGallery = LocalActor(ctxGallery);
const provideMovie = LocalActor(ctxMovie);

amateurRoute.create(
  path('/movie/{movieId}'), //
  mainView(moviePoolFeature, 'movie'),
  middleware(async (next) => {
    try {
      const movie = await get(Number(next.movieId));
      next.movie = movie;
      next.title = movie.getTitle();
    } catch (reason) {
      replaceUrl('/#/');

      throw reason;
    }
  }),
  Closure(({movie}) => {
    ASSERT: guard(movie, IS(Movie));
    const unlock = provideGallery(documentElement, movie);
    provideMovie(documentElement, movie);

    return () => unlock(documentElement);
  }),
);
